import { resizeWindow, scrollWindow, matchMedia } from 'actions/global';

export const addResizeListener = store => {
	let ticking = false;

	const resizeEvent = () => {
		const { clientWidth, clientHeight } = document.documentElement;

		if (!ticking) {
			window.requestAnimationFrame(() => {
				store.dispatch(resizeWindow(clientWidth, clientHeight));
				ticking = false;
			});
		}
		ticking = true;
	};

	window.addEventListener('resize', resizeEvent);
};

export const addScrollListener = store => {
	let ticking = false;

	const scrollEvent = () => {
		const { scrollY } = window;

		if (!ticking) {
			window.requestAnimationFrame(() => {
				store.dispatch(scrollWindow(scrollY));
				ticking = false;
			});
		}
		ticking = true;
	};

	window.addEventListener('scroll', scrollEvent, false);
};

export const addMatchMediaListener = store => {
	const phoneMedia = window.matchMedia('(max-width: 575px)');
	const tabletMedia = window.matchMedia('(max-width: 1199px) and (min-width: 576px)');
	const desktopMedia = window.matchMedia('(min-width: 1200px)');

	const handleMediaChange = callback => media => {
		if (media.matches) {
			callback();
		}
	};

	phoneMedia.addListener(handleMediaChange(() => store.dispatch(matchMedia('phone'))));
	tabletMedia.addListener(handleMediaChange(() => store.dispatch(matchMedia('tablet'))));
	desktopMedia.addListener(handleMediaChange(() => store.dispatch(matchMedia('desktop'))));

	// Initalize
	handleMediaChange(() => store.dispatch(matchMedia('phone')))(phoneMedia);
	handleMediaChange(() => store.dispatch(matchMedia('tablet')))(tabletMedia);
	handleMediaChange(() => store.dispatch(matchMedia('desktop')))(desktopMedia);
};



// WEBPACK FOOTER //
// ./src/util/event.js